import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss']
})
export class DashboardCardComponent implements OnInit {

  @Input() title: string;
  @Input() type: 'warning' | 'success' | 'danger';
  @Input() label: string;
  @Input() count: number;
  @Input() clickable: boolean;
  @Output('?clicked') clicked = new EventEmitter();
  
  constructor() { }

  ngOnInit(): void { }

  onClick() {
    console.log('clicked');
    this.clicked?.emit();
  }
}
